import { render, staticRenderFns } from "./AccessWalletMnemonic.vue?vue&type=template&id=7f1fa543&"
import script from "./AccessWalletMnemonic.vue?vue&type=script&lang=js&"
export * from "./AccessWalletMnemonic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports